import { FC } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { useMsal } from '@azure/msal-react';
import { Navigation as CommonNavigation } from '@vattenfall/wind-common-fe';

import { getUserMe } from '../../store/users';

import packageJson from '../../../package.json';
import { filterRoles, TEMP_PHOTO_URL } from '../../utils';
import { mainMenuItems } from './data';

const Navigation: FC = () => {
  const navigate = useNavigate();
  const { instance } = useMsal();
  const user = useSelector(getUserMe);

  const filterRolesFunc = filterRoles(user);
  const menuItems = mainMenuItems.filter((route) => filterRolesFunc(route.forRoles));

  const handleNavigation = (to: string) => {
    navigate(`${to}`);
  };

  const handleLogout = () => {
    try {
      instance.logoutRedirect();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <CommonNavigation
      bgColor="white"
      photoUrl={TEMP_PHOTO_URL}
      user={{ displayName: user.displayName, email: user.email, id: user.id }}
      mainMenuItems={menuItems}
      handleLogout={handleLogout}
      handleNavigation={handleNavigation}
      position="fixed"
      hostVersion={`${packageJson.version} (Host)`}
    />
  );
};

export { Navigation };
